<template>
  <div class="ui stacked blue segment">
    <div ref="trgtVue"></div>
  </div>
</template>

<script>
// import { local_api, error_toast } from "@/utils";
import filters from "@/filters";
import Vue from "vue";
// import _ from "lodash";

export default {
  name: "Receipt",
  filters: filters,
  components: {},
  props: {
    sale_in: Object,
    template_in: String,
  },
  data() {
    return { vueInstance: undefined, html_template: "", css_template: "" };
  },
  methods: {},
  mounted() {
    let vm = this;
    setTimeout(() => {
      if (vm.template_in) {
        vm.html_template = vm.template_in.html;
        vm.css_template = vm.template_in.css;

        let trgt = vm.$refs.trgtVue;
        try {
          let mixin = {};
          if (vm.template_in.js) {
            eval(`mixin = ${vm.template_in.js}`);
          }

          let _products = vm.sale_in.pos_sold_products.map(() => {
            return {
              products: vm.sale_in.pos_sold_products,
            };
          });
          vm.vueInstance = new Vue({
            el: trgt,
            mixins: [mixin],
            data() {
              return {
                products: _products,
                total: filters.formatCurrency(
                  vm.sale_in ? vm.sale_in.total : "",
                ),
              };
            },
            template: vm.html_template,
            created() {},
            mounted() {
              setTimeout(() => {
                window
                  .jQuery(vm.$el)
                  .append(`<style>${vm.css_template}</style>`);
              }, 200);
            },
          });
        } catch (error) {
          console.log(error);
        }
      }
    }, 2000);
  },
  created() {},
  watch: {},
  updated: function() {},
};
</script>

<style></style>
